(function () {
  var options = {}
  process.argv.forEach(function (val, idx, arr) {
    var matches = val.match(/^dotenv_config_(.+)=(.+)/)
    if (matches) {
      options[matches[1]] = matches[2]
    }
  })

  require('./lib/main').config(options)
})()



//////////////////
// WEBPACK FOOTER
// ./node_modules/dotenv/config.js
// module id = 1618
// module chunks = 10